<template>
  <div>
    <div class="designerbox">
      <div class="desbox">
        <el-aside width="100%" style="border: 1px solid #DCDFE6;border-radius: 10px 0 0 10px;" >
          <el-button icon="el-icon-info" v-on:click="saveXML" class="saveXml">保存流程模板</el-button>
          <div ref="canvas" style="width: 100%;height:560px"></div>
        </el-aside>
        <!-- <div class="canvas" ref="canvas" style="width: 100%; height: 560px" ></div> -->
      </div>
      <el-main style="border: 1px solid #dcdfe6; background-color: #fafafa">
        <el-form label-width="auto" size="mini" label-position="top">
          <!-- 动态显示属性面板 -->
          <component :is= "propsComponent" :element= "element"></component>
        </el-form>
      </el-main>
    </div>
  </div>
</template>
<style  scoped>
.designerbox{display: flex;width:100%;}
.desbox{width:80%;}
/deep/.bjs-container a {
    display: none;
}
.saveXml {
  display: flex;
}
</style>
<script>
import BpmnModeler from "bpmn-js/lib/Modeler";
import { xmlStr } from "./mock/xmlStr";
import "bpmn-js/dist/assets/diagram-js.css";
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css";
import bpmnHelper from "./js/helper/BpmnHelper";
import CommonProps from "./CommonProps.vue";
import ProcessProps from './ProcessProps.vue';
import StartEventProps from './StartEventProps.vue';
import EndEventProps from './EndEventProps.vue';
import IntermediateThrowEventProps from './IntermediateThrowEventProps.vue';
import ExclusiveGatewayProps from './ExclusiveGatewayProps.vue';
import ParallelGatewayProps from './ParallelGatewayProps.vue';
import InclusiveGatewayProps from './InclusiveGatewayProps.vue';
import UserTaskProps from './UserTaskProps.vue';
import SequenceFlowProps from './SequenceFlowProps.vue';
import CallActivityProps from './CallActivityProps.vue';
import activitiModdleDescriptor from "./js/activiti.json";
import customTranslate from "./js/customTranslate/customTranslate";
import customControlsModule from "./js/customControls";
import BpmData from "./BpmData";
// 接口
import { reqUrl,processReq,} from '@/api/flowble'
export default {
  data() {
    return {
      // bpmn建模器
      propsComponent:'CommonProps',
      bpmnModeler: null,
      container: null,
      canvas: null,
      element: null,
      params:{},
      bpmData: new BpmData(),
      defaultData: {
        'bpmn:StartEvent': '交易开始',
        'bpmn:EndEvent':'交易完成',
        'bpmn:IntermediateThrowEvent':'交易终止'
      }
     
    };
  },
  components: {
    CommonProps,
    ProcessProps,
    StartEventProps,
    EndEventProps,
    IntermediateThrowEventProps,
    ExclusiveGatewayProps,
    ParallelGatewayProps,
    InclusiveGatewayProps,
    UserTaskProps,
    SequenceFlowProps,
    CallActivityProps
  },
   provide: function () {
    return {
      bpmnModeler: this.getBpmnModeler,
      params: this.params
    }
  },
  created() {

  },
  mounted() {
    this.init();
  },
  methods: {
    // 保存流程模板
    // 保存XML
      saveXML(){
        try {
              const that = this;
              let _xml = null;
              let _svg = null;
              let modelId = that.$route.query.code;
              let name = that.$route.query.name;
              that.bpmnModeler.saveXML({format:true},function(err,xml){
                  if(err){
                    console.error('流程数据XML生成失败');
                    return;
                  }
                  _xml = xml;
              });
              console.log('=========_xml======='+_xml);
              that.bpmnModeler.saveSVG(function(err, svg) {
                    if(err){
                      console.error('流程数据SVG生成失败！');
                      return;
                    }
                    _svg = svg;
              });
              let reqData = {
                  jsonXml: _xml,
                  svgXml:_svg,
                  name: name,
                };
                let url = processReq.saveModel.format(modelId);
                that.reqPost(url,reqData);
        }catch(e){
          console.log('保存模板'+e);
        }
      },
      // 加载XML
      loadXml(successBack){
          try{
            const that = this;
             let modelId = that.$route.query.code;
              console.log("modelId"+modelId)
             let url = processReq.findModel.format(modelId);
             console.log("加载路径"+url)
             that.reqGet(url,{},(result)=>{
                   if(successBack && typeof successBack == 'function'){
                        successBack(result.jsonXml);
                  }
              });
          }catch(e){
            console.log('加载模板异常'+e);
          }
      },
      //初始化BpmnModeler
      init(){
        let canvas = this.$refs.canvas;
        var customTranslateModule = {
            translate: [ 'value', customTranslate ]
        };
        this.bpmnModeler = new BpmnModeler({
          container: canvas,
          //添加属性面板，添加翻译模块
          additionalModules: [
              customTranslateModule,
              customControlsModule
          ],
          //模块拓展，拓展activiti的描述
          moddleExtensions: {
              activiti: activitiModdleDescriptor
          }
        });
        let processCode = this.$route.query.code;
        let name = this.$route.query.name;
        // 业务编码
        let busCode = this.$route.query.busCode;

        let f_type = undefined;
        // 判断当前编辑是否为半自定义模板，如果为自定义模板，则设置模板type为customer
        if(busCode !== "user_defined "){
          f_type = "predefine"; // 半自定义
        }else{
          f_type = "customer"; // 自定义
        }

        //Safety_system_management 安全制度管理
        //Job_management 安全制度管理
        //Change_management 安全制度管理
        //File_management 安全制度管理
        //Target_responsibility_management 安全制度管理

        //
        this.createNewDiagram(processCode,name,f_type);
      },
    // init() {
    //   // 获取到属性ref为“canvas”的dom节点
    //   const canvas = this.$refs.canvas;
    //   var customTranslateModule = {
    //     translate: ["value", customTranslate],
    //   };
    //   // 建模
    //   this.bpmnModeler = new BpmnModeler({
    //     container: canvas,
    //     //添加属性面板，添加翻译模块
    //     additionalModules: [customTranslateModule, customControlsModule],
    //     //模块拓展，拓展activiti的描述
    //     moddleExtensions: {
    //       activiti: activitiModdleDescriptor,
    //     },
    //   });
    //   this.createNewDiagram();
    // },
    createNewDiagram(processCode,name,f_type) {
      // 将字符串转换成图显示出来
      const that = this;
        let bpmnXml = bpmnHelper.getBpmnTempate(processCode,name,f_type);
        that.loadXml((resultXml) => {
            if(resultXml){
              bpmnXml = resultXml;
            }
            that.bpmnModeler.importXML(bpmnXml,function(err){
                if(err){
                    console.log('bpmn文档导入失败'+err);
                } else {
                  // 绑定监听事件
                  that.success(processCode,name)
                }
            });
        });
    },
    success(processCode,name) {
        let processId = "p"+processCode;
        // 初始化element
        const elementRegistry = this.bpmnModeler.get('elementRegistry')
        const shape = elementRegistry.get(processId);
        // 更新名称
        bpmnHelper.updateProperties(shape,{"name":name});
        this.element = shape;
        this.addModelerListener()
        this.addEventBusListener()
        // 调控左侧工具栏
        this.adjustPalette();
      },
    // success(processCode, name) {
    //    let processId = processCode;
    //     // 初始化element
    //     const elementRegistry = this.bpmnModeler.get('elementRegistry')
    //     const shape = elementRegistry.get(processId);
    //     // 更新名称
    //     bpmnHelper.updateProperties(shape,{"name":name});
    //     this.element = shape;
    //     this.addModelerListener()
    //     this.addEventBusListener()
    //     //调控左侧工具栏
    //     this.adjustPalette();
    // },
     getBpmnModeler() {
        return this.bpmnModeler
      },

    // 调整左侧工具栏排版
    adjustPalette() {
      try {
        // 获取 bpmn 设计器实例
        const canvas = this.$refs.canvas;
        const djsPalette = canvas.children[0].children[1].children[4];
        const djsPalStyle = {
          width: "130px",
          padding: "5px",
          background: "white",
          left: "20px",
          borderRadius: 0,
        };
        for (var key in djsPalStyle) {
          djsPalette.style[key] = djsPalStyle[key];
        }
        const palette = djsPalette.children[0];
        const allGroups = palette.children;
        console.log(allGroups)
        allGroups[0].style["display"] = "none";
        allGroups[4].style["display"] = "none";
        allGroups[5].style["display"] = "none";
        allGroups[6].style["display"] = "none";
        allGroups[7].style["display"] = "none";

        // allGroups[1].children[1].style.display = "none";

        // 修改控件样式
        for (var gKey in allGroups) {
          let group = allGroups[gKey];
          for (var cKey in group.children) {
            const control = group.children[cKey];
            const controlStyle = {
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%",
              padding: "5px",
            };
            if (
              control.className &&
              control.dataset &&
              control.className.indexOf("entry") !== -1
            ) {
              const controlProps = this.bpmData.getControl(
                control.dataset.action
              );
              control.innerHTML = `<div style='font-size: 14px;font-weight:500;margin-left:15px;'>${controlProps["title"]}</div>`;
              for (var csKey in controlStyle) {
                control.style[csKey] = controlStyle[csKey];
              }
            }
          }
        }
        allGroups[1].children[1].style['display'] = "none";
        allGroups[3].children[0].style['display'] = 'none'
        allGroups[3].children[1].style['display'] = 'none'
        allGroups[3].children[3].style['display'] = 'none'
      } catch (e) {
        console.log(e);
      }
    },
    addModelerListener() {
      // 监听 modeler
      const bpmnjs = this.bpmnModeler;
      const that = this;
      // 'shape.removed', 'connect.end', 'connect.move'
      const events = ["shape.added", "shape.move.end", "shape.removed"];
      events.forEach(function (event) {
        that.bpmnModeler.on(event, (e) => {
          var elementRegistry = bpmnjs.get("elementRegistry");
          var shape = e.element ? elementRegistry.get(e.element.id) : e.shape;
          // console.log(shape)
          if (event === "shape.added") {
            console.log("新增了shape", 'lalal');
            // 展示新增图形的属性
            that.key = e.element.id.replace("_label", "");
            return
            that.propsComponent = bpmnHelper.getComponentByEleType(shape.type);
            that.element = e.element;
          } else if (event === "shape.move.end") {
            console.log("移动了shape");
            // 展示新增图形的属性
            that.key = shape.id;
            that.propsComponent = bpmnHelper.getComponentByEleType(shape.type);
            that.element = e.shape;
          } else if (event === "shape.removed") {
            console.log("删除了shape");
            // 展示默认的属性
            that.propsComponent = "CommonProps";
          }
        });
      });
    },
    addEventBusListener() {
      // 监听 element
      let that = this;
      const eventBus = this.bpmnModeler.get("eventBus");
      const eventTypes = [
        "element.click",
        "element.changed",
        "selection.changed",
      ];
      eventTypes.forEach(function (eventType) {
        eventBus.on(eventType, function (e) {
          if (eventType === "element.changed") {
            that.elementChanged(e);
          } else if (eventType === "element.click") {
            // console.log('dianji',that.element)

            if (!e || e.element.type == "bpmn:Process") {
              that.key = "1";
              that.propsComponent = "CommonProps";
              that.element = e.element;
            } else {
              // 展示新增图形的属性
              that.key = e.element.id;
              that.propsComponent = bpmnHelper.getComponentByEleType(
                e.element.type
              );
              that.element = e.element;
            }
            console.log('fuzhi',that.element)
          }
        });
      });
    },
     isInvalid (param) { // 判断是否是无效的值
        return param === null || param === undefined || param === ''
      },
      isSequenceFlow (type) { // 判断是否是线
        return type === 'bpmn:SequenceFlow'
      },
     elementChanged(e) {
        const id = e.element.id.replace('_label', '');
        var shape = this.getShape(id);
        this.element = shape;
        const that = this;
        if (!shape) {
          // 若是shape为null则表示删除, 无论是shape还是connect删除都调用此处
          console.log('无效的shape')
          // 上面已经用 shape.removed 检测了shape的删除, 要是删除shape的话这里还会被再触发一次
          console.log('删除了shape和connect')
          return
        }
        if (!this.isInvalid(shape.type)) {
          if (this.isSequenceFlow(shape.type)) {
            // console.log('改变了线')
          } else {
            that.setDefaultProperties();
          }
        }
      },
       getShape(id) {
        var elementRegistry = this.bpmnModeler.get('elementRegistry')
        return elementRegistry.get(id)
      },
      setDefaultProperties() {
        const that = this;
        const { element } = that;
        if (element) {
          // 这里可以拿到当前点击的节点的所有属性
          const { type, businessObject } = element;
          const { name } = businessObject;
          if (that.verifyIsEvent(type)) {
            const eventType = businessObject.eventDefinitions ? businessObject.eventDefinitions[0]['$type'] : '';
            console.log(eventType);
          } else if (this.verifyIsTask(type)) {
            const taskType = type;
            if(taskType.includes("UserTask")){
            }
            // console.log(taskType);
          }
          that.element['name'] = name || that.defaultData[element.type]
          }
      },
      verifyIsEvent(type) {
        return type.includes('Event')
      },
      verifyIsTask(type) {
        return type.includes('Task')
      },
  },
};
</script>

